export default "__VITE_ASSET__0e4da35b__"